import { render, staticRenderFns } from "./datacollect-form-1.vue?vue&type=template&id=616fa04f&scoped=true&"
import script from "./datacollect-form-1.vue?vue&type=script&lang=ts&"
export * from "./datacollect-form-1.vue?vue&type=script&lang=ts&"
import style0 from "./datacollect-form-1.vue?vue&type=style&index=0&id=616fa04f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616fa04f",
  null
  
)

export default component.exports